import type { ReactNode } from 'react';

interface FieldErrorProps {
  id?: string;
  'data-testid'?: string;
  children?: ReactNode;
}

export function FieldError({ id, 'data-testid': testId, children }: FieldErrorProps) {
  if (!children) return null;
  return (
    <p
      id={id}
      data-testid={testId}
      role="alert"
      className="text-xs text-error mt-1"
    >
      {children}
    </p>
  );
}
